import { i18n } from '~/i18nextSetup';
import type { Translations } from '~/translations/translations.type';

export const isValidTranslationKey = (key: string): key is keyof Translations => {
  return i18n.exists(key);
};
